import {
  FacilityConnectToAdminRequestDto,
  FacilityConnectToCaregiverRequestDto,
  FacilityConnectToCaregiverResponseDto,
  FacilityConnectToPatientRequestDto,
  FacilityConnectToPatientResponseDto,
  type FacilityResponseDto,
} from 'types/types';
import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import { CancelablePromise } from '../request/cancelable-promise';

export const getFacilityByUserId = (user_id: string): CancelablePromise<FacilityResponseDto[]> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `/facility/get_by_user_id/${user_id}`,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getFacilityById = (facilityId: string): CancelablePromise<FacilityResponseDto> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `/facility/${facilityId}`,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const getAllFacilities = (): CancelablePromise<FacilityResponseDto[]> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `/facility/get/`,
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const connectFacilityAndCaregiver = (
  payload: FacilityConnectToCaregiverRequestDto,
): CancelablePromise<FacilityConnectToCaregiverResponseDto> => {
  return __request(OpenAPI, {
    method: 'PUT',
    url: '/connectfacility/caregiver',
    query: {
      facility_id: payload.facilityId,
      caregiver_id: payload.caregiverId,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const connectFacilityAndAdmin = (
  payload: FacilityConnectToAdminRequestDto,
): CancelablePromise<FacilityConnectToPatientResponseDto> => {
  return __request(OpenAPI, {
    method: 'PUT',
    url: '/connectfacility/admin',
    query: {
      admin_id: payload.adminId,
      facility_id: payload.facilityId,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const connectFacilityAndPatient = (
  payload: FacilityConnectToPatientRequestDto,
): CancelablePromise<FacilityConnectToPatientResponseDto> => {
  return __request(OpenAPI, {
    method: 'PUT',
    url: '/connectfacility/patient',
    query: {
      patient_id: payload.patientId,
      facility_id: payload.facilityId,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const disconnectFacilityAndPatient = (payload: FacilityConnectToPatientRequestDto): CancelablePromise<void> => {
  return __request(OpenAPI, {
    method: 'DELETE',
    url: '/connectfacility/patient',
    query: {
      facility_id: payload.facilityId,
      patient_id: payload.patientId,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const disconnectFacilityAndCaregiver = (
  payload: FacilityConnectToCaregiverRequestDto,
): CancelablePromise<void> => {
  return __request(OpenAPI, {
    method: 'DELETE',
    url: '/connectfacility/caregiver',
    query: {
      facility_id: payload.facilityId,
      caregiver_id: payload.caregiverId,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};

export const disconnectFacilityAndAdmin = (payload: FacilityConnectToAdminRequestDto): CancelablePromise<void> => {
  return __request(OpenAPI, {
    method: 'DELETE',
    url: '/connectfacility/admin',
    query: {
      facility_id: payload.facilityId,
      admin_id: payload.adminId,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};
